import styles from './index.module.css';

const Auth = () => (
  <div className={styles.container}>
    {/* <h1>CSGO<span>Versus</span>.com</h1> */}
    <div className={styles.loader} />
  </div>
);

export default Auth;